import { Button } from "antd";
import Colors from "assets/Colors";

function CustomButton(props) {
  return (
    <Button
      {...props}
      style={{
        height: "40px",
        width: "100%",
        borderRadius: "2px",
        border: `1px solid ${Colors.background_dividers}`,
        borderColor: Colors.background_dividers,
        fontSize: "12px",
        ...props.style,
      }}
    >
      {props.children}
    </Button>
  );
}

export default CustomButton;
